//NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'actions';
import {
  areResultsOwnedByUser,
  hiddenTagListSelector,
  selectUserResult,
} from 'selectors';

import Layout from 'Components/Layout/Layout';
import ResultsNavigationButton from './ResultsNavigationButton';
import ResultsShareButton from './ResultsShareButton';
import HiddenTagsList from './HiddenTagsList';
import RecommendationList from './Recommendations/RecommendationList';

const REC_FILTERS = {
  isHidden: true,
};

class ResultsHidden extends Component {
  componentDidMount = () => {
    const {
      setResult,
      resultUUID,
      getFilteredRecommendations,
      getHiddenTags,
    } = this.props;
    setResult(resultUUID);
    getFilteredRecommendations();
    getHiddenTags();
  };

  render() {
    const { hiddenTags, resultUUID, areResultsOwnedByUser } = this.props;

    return (
      <Layout>
        <div className={`ResultsHidden-holder`}>
          <div className="ResultsHidden-heading">
            <ResultsNavigationButton path="index" resultUUID={resultUUID} />
            <h1>Hidden</h1>
            <ResultsShareButton />
          </div>
          <HiddenTagsList hiddenTags={hiddenTags} />
          <RecommendationList
            areResultsOwnedByUser={areResultsOwnedByUser}
            noResultsText="hidden"
          />
        </div>
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    resultUUID: selectUserResult(state).uuid,
    hiddenTags: hiddenTagListSelector(state),
    areResultsOwnedByUser: areResultsOwnedByUser(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getFilteredRecommendations: actions.getFilteredRecommendations.bind(
        null,
        REC_FILTERS
      ),
      getHiddenTags: actions.getHiddenTags,
      setResult: actions.setResult,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultsHidden);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/ResultsHidden.js